import { JobStatus } from "./job"
import { JobTrait } from "./job-trait"

export type EffectiveJobStatus = JobStatus | JobTrait.WAITING_ON_DELIVERY

export interface EffectiveJobStatusInput {
  jobStatus: JobStatus
  isWaitingForParts: boolean
  hasAwaitingAddonOrderResponse: boolean
  hasAnsweredAddonOrder: boolean
}

export function getEffectiveJobStatus(
  input: EffectiveJobStatusInput,
): EffectiveJobStatus {
  if (input.isWaitingForParts) {
    return JobTrait.WAITING_ON_DELIVERY
  }
  if (input.hasAwaitingAddonOrderResponse) {
    return JobStatus.SERVICE_PROPOSAL_SENT
  }
  if (input.hasAnsweredAddonOrder && input.jobStatus === JobStatus.COLLECTED) {
    return JobStatus.SERVICE_PROPOSAL_ACCEPTED
  }
  return input.jobStatus
}
